import httpClient from './httpClient';

const afpService = {
    // Obtener todas las AFP
    obtenerAfps: async () => {
        try {
            console.log('🔄 Obteniendo AFP...');
            const response = await httpClient.get('/afp');
            console.log('✅ AFP obtenidas:', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ Error al obtener AFP:', error.response?.data || error.message);
            throw error;
        }
    },

    // Obtener una AFP específica
    obtenerAfp: async (id) => {
        try {
            console.log(`🔄 Obteniendo AFP con ID: ${id}...`);
            const response = await httpClient.get(`/afp/${id}`);
            console.log('✅ AFP obtenida:', response.data);
            return response.data;
        } catch (error) {
            console.error(`❌ Error al obtener AFP ${id}:`, error.response?.data || error.message);
            throw error;
        }
    },

    // Crear nueva AFP
    crearAfp: async (afpData) => {
        try {
            console.log('🔄 Creando nueva AFP...', afpData);
            const response = await httpClient.post('/afp', afpData);
            console.log('✅ AFP creada:', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ Error al crear AFP:', error.response?.data || error.message);
            throw error;
        }
    },

    // Actualizar AFP
    actualizarAfp: async (id, afpData) => {
        try {
            console.log(`🔄 Actualizando AFP ${id}...`, afpData);
            const response = await httpClient.put(`/afp/${id}`, afpData);
            console.log('✅ AFP actualizada:', response.data);
            return response.data;
        } catch (error) {
            console.error(`❌ Error al actualizar AFP ${id}:`, error.response?.data || error.message);
            throw error;
        }
    },

    // Eliminar AFP
    eliminarAfp: async (id) => {
        try {
            console.log(`🔄 Eliminando AFP ${id}...`);
            const response = await httpClient.delete(`/afp/${id}`);
            console.log('✅ AFP eliminada:', response.data);
            return response.data;
        } catch (error) {
            console.error(`❌ Error al eliminar AFP ${id}:`, error.response?.data || error.message);
            throw error;
        }
    }
};

export default afpService; 